import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/dashboard",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "161"
  ],
  "cita": "Areas/CEDIS/Controllers/DashboardController.cs",
  "alias": [
    "/sistema/centro-de-distribucion"
  ]
} satisfies RutaProd;
